<template>
  <div>
    <div v-for="(str, index) in splitStr(item.clients.city)" :key="index">{{
      str
    }}</div>
  </div>
</template>

<script>
export default {
  name: "order-status-warehouse-city",
  props: {
    item: Object,
    options: Object,
  },
};
</script>
